/*
  PPV Duftfinder – Oberfläche (Dialog, Fragen, Ergebnis) für sections/quiz.liquid.
  Logik: assets/ppv-duftfinder-engine.js. Daten: templates/collection.duftfinder-daten.liquid
  (vorab gerenderte Profile aus dem Metafeld duftprofil.analyse; solange die Metafelder leer sind,
  ergänzt assets/ppv-duftfinder-profile.json die Profile).
  Ablauf: jede Antwort ist ein Tipp, danach geht es automatisch weiter – es gibt keinen Weiter-Knopf.
  Frage 1 als Bildkacheln (Flakons aus den Einstellungen der Section), Lieblingsduft optional:
  Treffer antippen = Ergebnis, sonst „Überspringen“.
*/
(function () {
  'use strict';

  var QUESTIONS = [
    { id: 'who', tiles: true, title: 'Für wen ist der Duft?', options: [
      ['sie', 'Für Sie'], ['ihn', 'Für Ihn'], ['unisex', 'Unisex'], ['egal', 'Ganz egal']
    ] },
    { id: 'fam', title: 'Welche Duftrichtung magst du am liebsten?', options: [
      ['suess', 'Süß & cremig', 'Vanille, Karamell, Tonka'], ['frisch', 'Frisch & zitrisch', 'Bergamotte, Zitrone, Meeresbrise'],
      ['blumig', 'Blumig & pudrig', 'Rose, Jasmin, Iris'], ['fruchtig', 'Fruchtig', 'Beeren, Pfirsich, Birne'],
      ['holzig', 'Holzig & erdig', 'Zeder, Sandelholz, Vetiver'], ['wuerzig', 'Würzig & orientalisch', 'Zimt, Pfeffer, Amber'],
      ['dunkel', 'Rauchig & ledrig', 'Leder, Oud, Weihrauch']
    ] },
    { id: 'avoid', title: 'Was magst du gar nicht?', options: [
      ['suess', 'Zu süß', 'Vanille, Karamell'], ['blumig', 'Zu blumig', 'Rose, Jasmin, Puder'],
      ['frisch', 'Zu frisch', 'Zitrus, Meeresbrise'], ['schwer', 'Zu schwer', 'Oud, Leder, Rauch'],
      ['keine', 'Ich mag alles', 'Keine Einschränkung']
    ] },
    { id: 'season', title: 'Wann trägst du ihn am liebsten?', options: [
      ['fruehling', 'Frühling', 'Milde, helle Tage'], ['sommer', 'Sommer', 'Warme Tage'],
      ['herbst', 'Herbst', 'Kühle Tage'], ['winter', 'Winter', 'Kalte Tage'], ['ganzjaehrig', 'Das ganze Jahr', 'Ein Allrounder']
    ] },
    { id: 'occ', title: 'Wofür suchst du ihn?', options: [
      ['alltag', 'Für jeden Tag', 'Unkompliziert und vielseitig'], ['buero', 'Fürs Büro', 'Gepflegt und dezent'],
      ['freizeit', 'Freizeit & Sport', 'Leicht und unbeschwert'], ['abend', 'Abends & Ausgehen', 'Anziehend und präsent']
    ] },
    { id: 'ref', search: true, title: 'Gibt es einen Duft, den du schon magst?', hint: 'Optional – wir suchen dann in dieser Richtung.' }
  ];
  /* Ausschluss-Optionen, die der gewählten Richtung widersprechen, werden ausgeblendet */
  var CONFLICT = { suess: ['suess'], blumig: ['blumig'], frisch: ['frisch'], schwer: ['wuerzig', 'dunkel'] };
  var ADVANCE_DELAY = 220;
  var CHECK = '<svg width="11" height="9" viewBox="0 0 11 9" fill="none" stroke="#fff" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 4.5l3 3L10 1"/></svg>';
  var CHEVRON = '<svg width="8" height="13" viewBox="0 0 8 13" fill="none" stroke="#a1a1a6" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1.5 1.5l5 5-5 5"/></svg>';
  var SEARCH = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><circle cx="7.75" cy="7.75" r="5.75"/><path d="M12 12l4.5 4.5"/></svg>';

  var DIACRITICS = new RegExp('[' + String.fromCharCode(0x300) + '-' + String.fromCharCode(0x36f) + ']', 'g');
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  };
  var fold = function (s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(DIACRITICS, '').replace(/ß/g, 'ss');
  };
  var euro = function (v) { return Number(v).toFixed(2).replace('.', ',') + ' €'; };
  var emit = function (name, detail) {
    window.dataLayer = window.dataLayer || [];
    var ev = { event: name };
    for (var k in detail || {}) ev[k] = detail[k];
    window.dataLayer.push(ev);
  };

  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var Engine = window.PPVDuftfinderEngine;
    var $ = function (s, c) { return (c || root).querySelector(s); };
    var overlay = $('.ppv-finder__overlay');
    var dialog = $('.ppv-finder__dialog');
    var stage = $('.ppv-finder__stage');
    var loading = $('.ppv-finder__loading');
    var results = $('.ppv-finder__results');
    var count = $('.ppv-finder__count');
    var progress = $('.ppv-finder__progress span');
    var launcher = $('.ppv-finder__launcher');
    var cfg = root.dataset;
    var step = 0, answers = {}, ctx = null, dataPromise = null, lastFocus = null, advanceTimer = 0;

    /* ---------- Daten ---------- */
    function fetchPage(p) {
      return fetch(cfg.dataUrl + '&page=' + p, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('Daten ' + r.status);
        return r.text();
      }).then(function (t) { return JSON.parse(t); });
    }
    function loadData() {
      if (dataPromise) return dataPromise;
      var guess = [1, 2, 3].map(function (p) { return fetchPage(p); });
      dataPromise = Promise.all(guess).then(function (pages) {
        var more = [];
        for (var p = pages.length + 1; p <= (pages[0].pages || 1); p++) more.push(fetchPage(p));
        return Promise.all(more).then(function (rest) {
          return pages.concat(rest).filter(function (pg) { return pg.page <= pg.pages; })
            .reduce(function (all, pg) { return all.concat(pg.items || []); }, []);
        });
      }).then(function (items) {
        /* Metafeld hat Vorrang; fehlt es (Befüllung läuft noch), ergänzt die Übergangsdatei das Profil je Produkt */
        var fromMeta = items.filter(function (it) { return it.d; }).length;
        if (!cfg.fallbackUrl || fromMeta === items.length) return { items: items, source: { metafelder: fromMeta, uebergang: 0 } };
        return fetch(cfg.fallbackUrl, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; })
          .then(function (fb) {
            var prof = (fb && fb.profile) || {}, added = 0;
            items.forEach(function (it) {
              var p = prof[it.h];
              if (!it.d && p) { it.d = p.d; it.s = p.s; it.o = p.o; it.y = p.y; added++; }
            });
            return { items: items, source: { metafelder: fromMeta, uebergang: added } };
          });
      }).then(function (res) {
        ctx = Engine.prepare(res.items);
        ctx.source = res.source;
        return ctx;
      });
      dataPromise.catch(function () { dataPromise = null; });
      return dataPromise;
    }

    /* ---------- Fortschritt, Öffnen, Schließen ---------- */
    function setTop(label, pct) {
      count.textContent = label;
      progress.style.width = pct + '%';
    }
    function focusables() {
      return Array.prototype.filter.call(dialog.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])'), function (el) {
        return !el.disabled && el.offsetParent !== null;
      });
    }
    function open() {
      clearTimeout(advanceTimer);
      lastFocus = document.activeElement;
      step = 0; answers = {};
      overlay.hidden = false;
      document.documentElement.classList.add('ppv-finder-lock');
      document.body.classList.add('ppv-finder-lock');
      loadData().catch(function () {});
      emit('ppv_duftfinder_open');
      showQuestion(true);
    }
    function close() {
      clearTimeout(advanceTimer);
      overlay.hidden = true;
      document.documentElement.classList.remove('ppv-finder-lock');
      document.body.classList.remove('ppv-finder-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    /* ---------- Fragen ---------- */
    function visibleOptions(q) {
      if (q.id !== 'avoid') return q.options;
      return q.options.filter(function (o) {
        return (CONFLICT[o[0]] || []).indexOf(answers.fam) < 0;
      });
    }
    function isSelected(q, v) {
      return answers[q.id] === v;
    }
    /* Frage 1: Flakon je Antwort, bei „Ganz egal“ alle drei */
    function tileMedia(v) {
      var img = function (src, cls) {
        return src ? '<img' + (cls ? ' class="' + cls + '"' : '') + ' src="' + esc(src) + '" alt="" width="120" height="160" loading="lazy">' : '';
      };
      if (v === 'egal') {
        return '<span class="ppv-finder__tile-mix" aria-hidden="true">' +
          img(cfg.imgSie, 'is-left') + img(cfg.imgUnisex, 'is-mid') + img(cfg.imgIhn, 'is-right') + '</span>';
      }
      return '<span class="ppv-finder__tile-media" aria-hidden="true">' + img({ sie: cfg.imgSie, ihn: cfg.imgIhn, unisex: cfg.imgUnisex }[v]) + '</span>';
    }
    function showQuestion(focusHeading) {
      var q = QUESTIONS[step];
      dialog.classList.remove('is-result');
      setTop('Frage ' + (step + 1) + ' von ' + QUESTIONS.length, ((step + 1) / QUESTIONS.length) * 100);
      stage.hidden = false; loading.hidden = true; results.hidden = true; results.innerHTML = '';
      if (q.id === 'avoid' && answers.avoid) {
        var allowed = visibleOptions(q).map(function (o) { return o[0]; });
        if (allowed.indexOf(answers.avoid) < 0) delete answers.avoid;
      }
      var body;
      if (q.search) body = searchMarkup();
      else if (q.tiles) body = '<div class="ppv-finder__options ppv-finder__tiles" role="group" aria-labelledby="ppv-finder-q">' +
        q.options.map(function (o) {
          var on = isSelected(q, o[0]);
          return '<button type="button" class="ppv-finder__option ppv-finder__tile' + (on ? ' is-selected' : '') + '" data-value="' + esc(o[0]) + '" aria-pressed="' + on + '">' +
            tileMedia(o[0]) + '<strong>' + esc(o[1]) + '</strong>' +
            '<span class="ppv-finder__check">' + CHECK + '</span></button>';
        }).join('') + '</div>';
      else body = '<div class="ppv-finder__options" role="group" aria-labelledby="ppv-finder-q">' +
        visibleOptions(q).map(function (o) {
          var on = isSelected(q, o[0]);
          return '<button type="button" class="ppv-finder__option' + (on ? ' is-selected' : '') + '" data-value="' + esc(o[0]) + '" aria-pressed="' + on + '">' +
            '<span class="ppv-finder__option-copy"><strong>' + esc(o[1]) + '</strong> <small>' + esc(o[2]) + '</small></span>' +
            '<span class="ppv-finder__check">' + CHECK + '</span></button>';
        }).join('') + '</div>';
      /* Keine Weiter-Knöpfe: nur „Zurück“ und bei der freiwilligen letzten Frage „Überspringen“ */
      var actions = '';
      if (step) actions += '<button type="button" class="ppv-finder__text-button ppv-finder__back">Zurück</button>';
      if (q.search) actions += '<button type="button" class="ppv-finder__text-button ppv-finder__skip">Überspringen</button>';
      stage.innerHTML = '<div class="ppv-finder__question">' +
        '<h3 id="ppv-finder-q" tabindex="-1">' + esc(q.title) + '</h3>' +
        (q.hint ? '<p class="ppv-finder__hint">' + esc(q.hint) + '</p>' : '') + body +
        (actions ? '<div class="ppv-finder__actions' + (step && q.search ? ' is-row' : '') + '">' + actions + '</div>' : '') + '</div>';
      wireQuestion(q);
      overlay.scrollTop = 0;
      if (focusHeading) { var h = $('h3', stage); if (h) h.focus({ preventScroll: true }); }
    }
    function advance() {
      if (step < QUESTIONS.length - 1) { step++; showQuestion(true); } else calculate();
    }
    function wireQuestion(q) {
      var list = $('.ppv-finder__options', stage);
      if (list) list.addEventListener('click', function (e) {
        var btn = e.target.closest('.ppv-finder__option');
        if (!btn || list.classList.contains('is-answered')) return;
        /* Antippen = Antwort: kurz Häkchen zeigen, dann automatisch weiter */
        answers[q.id] = btn.dataset.value;
        list.classList.add('is-answered');
        list.querySelectorAll('.ppv-finder__option').forEach(function (o) {
          var on = o === btn;
          o.classList.toggle('is-selected', on);
          o.setAttribute('aria-pressed', String(on));
        });
        advanceTimer = setTimeout(function () { if (!overlay.hidden) advance(); }, ADVANCE_DELAY);
      });
      var back = $('.ppv-finder__back', stage);
      if (back) back.addEventListener('click', function () { clearTimeout(advanceTimer); step--; showQuestion(true); });
      var skip = $('.ppv-finder__skip', stage);
      if (skip) skip.addEventListener('click', function () { clearTimeout(advanceTimer); answers.ref = null; calculate(); });
      if (q.search) wireSearch();
    }

    /* ---------- Lieblingsduft (Suche) ---------- */
    function searchMarkup() {
      return '<div class="ppv-finder__search">' +
        '<label class="ppv-finder__search-field"><span class="ppv-finder__search-icon">' + SEARCH + '</span>' +
        '<input type="search" autocomplete="off" spellcheck="false" placeholder="Duft oder Marke suchen" aria-label="Duft oder Marke suchen" aria-controls="ppv-finder-hits"></label>' +
        '<div class="ppv-finder__hits" id="ppv-finder-hits" aria-live="polite"></div></div>';
    }
    function hitMarkup(it, on) {
      return '<button type="button" class="ppv-finder__hit' + (on ? ' is-selected' : '') + '" data-handle="' + esc(it.h) + '" aria-pressed="' + on + '">' +
        (it.src.i ? '<img src="' + esc(it.src.i) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="ppv-finder__hit-ph"></span>') +
        '<span class="ppv-finder__hit-copy"><strong>' + esc(it.t) + '</strong> <small>' + esc(it.b) + '</small></span>' +
        '<span class="ppv-finder__check">' + CHECK + '</span></button>';
    }
    function wireSearch() {
      var input = $('.ppv-finder__search input', stage);
      var hits = $('.ppv-finder__hits', stage);
      var timer = 0, picked = false;
      function render() {
        var chosen = answers.ref && ctx ? ctx.byHandle[answers.ref] : null;
        var q = fold(input.value).trim();
        if (!ctx) { hits.innerHTML = '<p class="ppv-finder__hits-note">Düfte werden geladen …</p>'; return; }
        var list = [];
        if (q) {
          var words = q.split(/\s+/);
          list = ctx.all.filter(function (it) {
            var hay = it._hay || (it._hay = fold(it.t + ' ' + it.b));
            return words.every(function (w) { return hay.indexOf(w) > -1; });
          }).sort(function (a, b) { return (a.r == null ? 999 : a.r) - (b.r == null ? 999 : b.r); }).slice(0, 5);
        }
        if (chosen) list = [chosen].concat(list.filter(function (it) { return it !== chosen; })).slice(0, 5);
        hits.innerHTML = list.length ? list.map(function (it) { return hitMarkup(it, it === chosen); }).join('')
          : (q ? '<p class="ppv-finder__hits-note">Kein Duft gefunden.</p>' : '');
      }
      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(render, 120); });
      /* Treffer antippen = Lieblingsduft gewählt, kurz Häkchen zeigen, dann direkt zum Ergebnis */
      hits.addEventListener('click', function (e) {
        var btn = e.target.closest('.ppv-finder__hit');
        if (!btn || picked) return;
        picked = true;
        answers.ref = btn.dataset.handle;
        render();
        advanceTimer = setTimeout(function () { if (!overlay.hidden) calculate(); }, ADVANCE_DELAY);
      });
      loadData().then(render, function () { hits.innerHTML = ''; });
      render();
    }

    /* ---------- Ergebnis ---------- */
    function twoMlMissing(items) {
      return items.filter(function (it) { return !it.id || !it.a; });
    }
    function addBundle(items, button, status) {
      status.classList.remove('is-error');
      var missing = twoMlMissing(items);
      if (missing.length) {
        return Promise.reject(new Error('Für ' + missing.map(function (it) { return it.t; }).join(', ') + ' ist die 2-ml-Probe gerade nicht verfügbar.'));
      }
      button.disabled = true;
      button.textContent = 'Bundle wird hinzugefügt …';
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items.map(function (it) { return { id: it.id, quantity: 1, properties: { '_Duftfinder-Bundle': '3 Empfehlungen' } }; }) })
      }).then(function (r) {
        if (!r.ok) throw new Error('Das Bundle konnte gerade nicht in den Warenkorb gelegt werden.');
        status.textContent = 'Alle drei Duftproben wurden hinzugefügt.';
        emit('ppv_duftfinder_bundle_add', { product_handles: items.map(function (it) { return it.h; }) });
        location.href = cfg.discountCode
          ? '/discount/' + encodeURIComponent(cfg.discountCode) + '?redirect=' + encodeURIComponent('/cart')
          : '/cart';
      });
    }
    function notesLine(prepared, item) {
      var notes = Engine.topNotes(prepared, 2).map(function (t, i) { return i ? t.toLowerCase() : t; }).join(', ');
      return [item.b, notes].filter(Boolean).join(' · ');
    }
    function renderResults(ranked) {
      var items = ranked.map(function (r) { return r.item; });
      var best = ranked[0], alts = ranked.slice(1);
      dialog.classList.add('is-result');
      setTop('Dein Ergebnis', 100);
      results.innerHTML = '<div class="ppv-finder__result-head"><h3 id="ppv-finder-q" tabindex="-1">Unsere Empfehlungen für dich</h3></div>' +
        '<article class="ppv-finder__match">' +
          (best.item.i ? '<img class="ppv-finder__match-img" src="' + esc(best.item.i) + '" alt="' + esc(best.item.t) + '" width="200" height="200">' : '<span></span>') +
          '<div class="ppv-finder__match-copy"><span class="ppv-finder__badge">Beste Übereinstimmung</span>' +
          '<h4>' + esc(best.item.t) + '</h4><p class="ppv-finder__vendor">' + esc(notesLine(best.prepared, best.item)) + '</p>' +
          '<a class="ppv-finder__buy" href="/products/' + esc(best.item.h) + '">' + (best.item.p != null ? 'Probe ab ' + euro(best.item.p) : 'Duftprobe ansehen') + '</a></div>' +
        '</article>' +
        '<div class="ppv-finder__alternatives">' + alts.map(function (r) {
          return '<a class="ppv-finder__alt" href="/products/' + esc(r.item.h) + '">' +
            (r.item.i ? '<img src="' + esc(r.item.i) + '" alt="" width="60" height="60" loading="lazy">' : '') +
            '<span class="ppv-finder__alt-copy"><strong>' + esc(r.item.t) + '</strong> <small>' + esc(r.item.b) + '</small></span>' + CHEVRON + '</a>';
        }).join('') + '</div>' +
        '<div class="ppv-finder__actions">' +
          (items.length === 3 && !twoMlMissing(items).length ? '<button class="ppv-finder__bundle-button" type="button">' + esc(cfg.bundleLabel) + '</button>' : '') +
          '<p class="ppv-finder__bundle-status" role="status"></p>' +
          '<button class="ppv-finder__text-button ppv-finder__restart" type="button">Beratung neu starten</button>' +
        '</div>';
      var bundleButton = $('.ppv-finder__bundle-button', results);
      var bundleStatus = $('.ppv-finder__bundle-status', results);
      if (bundleButton) bundleButton.addEventListener('click', function () {
        addBundle(items, bundleButton, bundleStatus).catch(function (err) {
          bundleButton.disabled = false;
          bundleButton.textContent = cfg.bundleLabel;
          bundleStatus.classList.add('is-error');
          bundleStatus.textContent = (err && err.message) || 'Das Bundle konnte gerade nicht hinzugefügt werden.';
        });
      });
      $('.ppv-finder__restart', results).addEventListener('click', function () { step = 0; answers = {}; showQuestion(true); });
      loading.hidden = true; results.hidden = false; overlay.scrollTop = 0;
      var h = $('h3', results); if (h) h.focus({ preventScroll: true });
    }
    function calculate() {
      clearTimeout(advanceTimer);
      stage.hidden = true; stage.innerHTML = ''; results.hidden = true; loading.hidden = false;
      setTop('Auswertung', 100);
      var started = Date.now();
      loadData().then(function () {
        var a = {
          who: answers.who, fam: answers.fam ? [answers.fam] : [], season: answers.season, occ: answers.occ, ref: answers.ref || null,
          avoid: answers.avoid && answers.avoid !== 'keine' ? [answers.avoid] : []
        };
        var ranked = Engine.recommend(ctx, a, 3);
        if (!ranked.length) throw new Error('Keine Düfte gefunden');
        emit('ppv_duftfinder_result', { answers: a, product_handles: ranked.map(function (r) { return r.item.h; }) });
        setTimeout(function () { renderResults(ranked); }, Math.max(0, 450 - (Date.now() - started)));
      }).catch(function () {
        loading.hidden = true; results.hidden = false;
        results.innerHTML = '<div class="ppv-finder__error"><h3 id="ppv-finder-q" tabindex="-1">Die Auswertung konnte gerade nicht geladen werden.</h3>' +
          '<p>Bitte versuche es in einem Moment erneut.</p>' +
          '<div class="ppv-finder__actions"><button class="ppv-finder__next ppv-finder__retry" type="button">Erneut versuchen</button></div></div>';
        $('.ppv-finder__retry', results).addEventListener('click', calculate);
      });
    }

    /* ---------- Ereignisse ---------- */
    launcher.addEventListener('click', open);
    $('.ppv-finder__close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) {
      if (overlay.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
      }
    });
    var scrollFrame = 0;
    window.addEventListener('scroll', function () {
      if (!scrollFrame) scrollFrame = requestAnimationFrame(function () {
        scrollFrame = 0;
        launcher.classList.toggle('is-dismissed', window.scrollY > 20);
      });
    }, { passive: true });
    window.addEventListener('pageshow', function () {
      launcher.classList.remove('is-dismissed');
      if (window.scrollY > 20) setTimeout(function () { launcher.classList.toggle('is-dismissed', window.scrollY > 20); }, 900);
    });
    document.addEventListener('ppv:open-duftfinder', open);
    window.PPVDuftfinder = {
      open: open, close: close,
      /* für Tests: Empfehlung zu Antworten ohne Oberfläche */
      recommend: function (a, n) {
        return loadData().then(function () {
          return Engine.recommend(ctx, a, n || 3).map(function (r) { return { h: r.item.h, t: r.item.t, b: r.item.b, tier: r.tier, score: r.score }; });
        });
      },
      data: function () { return loadData().then(function () { return { source: ctx.source, items: ctx.items.length }; }); }
    };
    var params = new URLSearchParams(location.search);
    if (params.get('duftfinder') === 'open' || location.hash === '#duftfinder') setTimeout(open, 180);
  }

  function boot() {
    document.querySelectorAll('.ppv-finder[data-data-url]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
